export const createTooltipHelper = (SCElement, tooltipData) => {
  const delay = window.innerWidth > window.innerHeight ? 3000 : 1000
  setTimeout(() => window.InitSmartContractTooltip(SCElement, tooltipData), delay)
}
